import { format } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import * as PropTypes from 'prop-types'; 
import { IHistory } from '../../../interfaces';
import { PlantModel } from '../../../model/PlantModel';
import { QuestionModel } from '../../../model/QuestionModel';
import { parseJwt } from '../../../services/loginService';
import { getQuarterlyFormQuestions, submitQuarterlyForm } from '../../../services/quarterlyFormService';
import { dispatch, marshallAnswers, getPageTitle } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { FormInput } from '../../reusableComponents/FormComponents/FormInput';
import { InputRow } from '../../reusableComponents/FormComponents/InputRow';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { QuarterlyFormModel } from '../../../model/QuarterlyFormModel';
import './quarterlyForm.scss';

export interface IQTRVisualFormProps {
    plantRegion: string;
    plantId: string;
    userUID: string;
    date: string;
    userName: string;
    outfall: string;
    type: string;
    formId: string;
    questions: QuestionModel[];
    history: IHistory;
    formInstance: QuarterlyFormModel;
    form;
}

export interface IQTRVisualFormState {
    natureOfDis: string;
    waterSampledIn: string;
    foam: string;
    settledSolids: string;
    oilSheen: string;
    suspendedSolids: string;
    floatingSolids: string;
    swModified: string;
    answers: Object;
    swModifiedComments: string;
}

export class QTRVisualFormImpl extends React.Component<IQTRVisualFormProps, IQTRVisualFormState> {
    constructor(props: IQTRVisualFormProps) {
        super(props);
        this.state = {
            natureOfDis: '',
            waterSampledIn: '',
            foam: '',
            settledSolids: '',
            oilSheen: '',
            suspendedSolids: '',
            floatingSolids: '',
            swModified: '',
            answers: {},
            swModifiedComments:''
        };
    }

    promise = async () => {
        await getQuarterlyFormQuestions(this.props.type, this.props.formId);
    }

    loadValues = () => {
        const answers = {};
        if (this.props.formId) {
            this.props.questions.forEach((instance, index) => {
                answers[instance.props.question] = instance.props.answer;
                dispatch(actions.change(`forms.QTRVisualForm.${instance.props.quesNum}`, instance.props.answer));
            });
            this.setState({
                answers,
                natureOfDis: answers['Nature of Discharge'],
                waterSampledIn: answers['Sampled within 30 minutes?'],
                floatingSolids: answers['Floating Solids?'],
                foam: answers['Foam?'],
                settledSolids: answers['Settled Solids?'],
                oilSheen: answers['Oil Sheen?'],
                suspendedSolids: answers['Suspended Solids?'],
                swModified: answers['SWP3 need modification?'],
                swModifiedComments: answers['Why?']
            });
        }
        dispatch(actions.change('forms.QTRVisualForm.1', this.props.userName));
        dispatch(actions.change('forms.QTRVisualForm.24', this.props.outfall));
    }

    refs: {
        images: ImageUpload;
    };getChildContext() {
        return { formModel: 'forms.QTRVisualForm' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };

    handleFormSubmit = async (values) => { 
        const answer = marshallAnswers(values);  
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'QTRVisual',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.QTRVisualForm.deletedImages || [],
            SignatureUrls: [],
            AssociatedTo: null
        };
        return await submitQuarterlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    handleButtonClick = (value, quesNum, name) => {
        this.setState({
            [name]: value
        });
        dispatch(actions.change(`forms.QTRVisualForm.${quesNum}`, value));
        if(name==='swModified' && value==='No') {
            this.setState({swModifiedComments:null});
            dispatch(actions.change(`forms.QTRVisualForm.21`, null));
        }
    }

    renderYesNoButtons = () => {
        const arrayOfInputs = [
            { label: 'Floating Solids:', quesNum: 13, name: 'floatingSolids' },
            { label: 'Foam:', quesNum: 14, name: 'foam', },
            { label: 'Settled Solids:', quesNum: 15, name: 'settledSolids', },
            { label: 'Oil Sheen:', quesNum: 16, name: 'oilSheen', },
            { label: 'Suspended Solids:', quesNum: 17, name: 'suspendedSolids', }];
        return <div className="radio-buttons" >
            {arrayOfInputs.map((data, index) => {
                return <div className="radio-input-container" key={index} >
                    <Label label={data.label} />
                    <div className="buttons" >
                        <RadioButton
                            handleButtonClick={() => this.handleButtonClick('Yes', data.quesNum, data.name)}
                            name={data.name}
                            label="Yes"
                            natureOfDis={this.state[data.name]}
                        />
                        <RadioButton
                            handleButtonClick={() => this.handleButtonClick('No', data.quesNum, data.name)}
                            name={data.name}
                            label="No"
                            natureOfDis={this.state[data.name]}
                        />
                    </div>
                </div>;
            })}
        </div>;
    }

    renderContent = () => {
        const { plantId, plantRegion, date } = this.props;
        const plantInstance = PlantModel.get(plantId); 
        return <Form loadDefaultValues={this.loadValues} onSubmit={this.handleFormSubmit} model="forms.QTRVisualForm"  >
            <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                <Row label="Plant Region" value={plantRegion} />
                <Row label="Plant ID" value={plantInstance ? plantInstance.props.PlantId : ''} />
                <Row label="Date" value={date} />
                <Row label="Outfall Number" value={this.props.outfall} />
            </div>
            <BoldLabel label="Time discharge was started:" />
            <FormInput
                model=".2"
                onChange={null}
                placeholder="Enter the time when discharge was started..."
                type="text"
                defaultValue={this.state.answers['Time Started']}
            />
            <BoldLabel label="Time water was sampled:" />
            <FormInput
                model=".3"
                onChange={null}
                placeholder="Enter the time when water was sampled..."
                type="text"
                defaultValue={this.state.answers['Time Water Sampled']}
            />
            <BoldLabel label="Sampling Personnel:" />
            <div className="sub-questions" >
                <div className="single-line-inputs" >
                    <CustomInput
                        model=".4"
                        placeholder="Enter name..."
                        label="Name:"
                        type="text"
                        defaultValue={this.state.answers['Sampling Name']}
                    />
                    <CustomInput
                        model=".5"
                        placeholder="Enter title..."
                        label="Title:"
                        type="text"
                        defaultValue={this.state.answers['Sampling Title']}
                    />
                </div>
            </div>
            <BoldLabel label="Nature of Discharge:" />
            <div className="sub-questions" >
                <div className="buttons" >
                    <RadioButton
                        handleButtonClick={e => this.handleButtonClick('Storm Event', 6, 'natureOfDis')}
                        label="Storm Event"
                        name="natureOfDis"
                        natureOfDis={this.state.natureOfDis}
                    />
                    <RadioButton
                        handleButtonClick={e => this.handleButtonClick('Snow Melt', 6, 'natureOfDis')}
                        label="Snow Melt"
                        name="natureOfDis"
                        natureOfDis={this.state.natureOfDis}
                    />
                    <RadioButton
                        handleButtonClick={e => this.handleButtonClick('Other', 6, 'natureOfDis')}
                        name="natureOfDis"
                        label="Other"
                        natureOfDis={this.state.natureOfDis}
                    />
                </div>
            </div>
            <BoldLabel label="Was water sampled within 30 minutes?" />
            <div className="sub-questions" >
                <div className="buttons" >
                    <RadioButton
                        handleButtonClick={e => this.handleButtonClick('Yes', 7, 'waterSampledIn')}
                        name="waterSampledIn"
                        label="Yes"
                        natureOfDis={this.state.waterSampledIn}
                    />
                    <RadioButton
                        handleButtonClick={e => this.handleButtonClick('No', 7, 'waterSampledIn')}
                        name="waterSampledIn"
                        label="No"
                        natureOfDis={this.state.waterSampledIn}
                    />
                </div>
            </div>
            {this.state.waterSampledIn === 'No' ?
                <div className="comment-input" >
                    <CustomInput
                        type="textarea"
                        model=".8"
                        placeholder="Comments..."
                        label="Why Not?:"
                        defaultValue={this.state.answers['Why not?']}
                    />
                </div>
                : ''
            }
            <BoldLabel label="Quality of Water Discharge:" />
            <div className="sub-questions" >
                <div className="single-line-inputs" >
                    <CustomInput
                        defaultValue={this.state.answers['Color']}
                        type="text"
                        model=".9"
                        placeholder="Color"
                        label="Color:"
                    />
                    <CustomInput
                        type="text"
                        model=".10"
                        placeholder="Odor"
                        label="Odor:"
                        defaultValue={this.state.answers['Odor']}
                    />
                    <CustomInput
                        defaultValue={this.state.answers['Clarity']}
                        type="text"
                        model=".11"
                        placeholder="Clarity"
                        label="Clarity:"
                    />
                    <CustomInput
                        defaultValue={this.state.answers['Turbidity']}
                        type="text"
                        model=".12"
                        placeholder="Turbidity"
                        label="Turbidity:"
                    />
                </div>
                {this.renderYesNoButtons()}
                <div className="comment-input" >
                    <CustomInput
                        type="textarea"
                        model=".18"
                        placeholder="Comments..."
                        label="Any other obvious indicators of storm water pollution?:"
                        defaultValue={this.state.answers['Other obvious indiciators of storm water pollution?']}
                    />
                </div>
            </div>
            <BoldLabel label="Pollution Prevention Team Review:" />
            <div className="sub-questions" >
                <div className="comment-input" >
                    <CustomInput
                        type="textarea"
                        model=".19"
                        placeholder="Comments..."
                        label="Probable sources of pollutants?..."
                        defaultValue={this.state.answers['Probable sources of pollutants:']}
                    />
                </div>
            </div>
            <BoldLabel label="Does SWP3 need to be modified at this time?" />
            <div className="sub-questions" >
                <div className="buttons" >
                    <RadioButton
                        handleButtonClick={() => this.handleButtonClick('Yes', 20, 'swModified')}
                        name="swModified"
                        label="Yes"
                        natureOfDis={this.state.swModified}
                    />
                    <RadioButton
                        handleButtonClick={() => this.handleButtonClick('No', 20, 'swModified')}
                        name="swModified"
                        label="No"
                        natureOfDis={this.state.swModified}
                    />
                </div>
            </div>
            {this.state.swModified === 'Yes' ?
                <div className="comment-input" >
                    <CustomInput
                        type="textarea"
                        model=".21"
                        placeholder="Comments..."
                        label="Why ?:"
                        defaultValue={this.state.swModifiedComments}
                    />
                </div>
                : ''
            }
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:"
                defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
            />
            <FormFooter />
        </Form>;
    }

    render() {
        let day = this.props.date, cdate = new Date(day);
        let month = cdate.getMonth() + 1;
        let year = cdate.getFullYear();
        let qtr = '';
        if (month <= 3) {
            qtr = '1st';
        } else if (month > 3 && month <= 6) {
            qtr = '2nd';
        } else if (month > 6 && month <= 9) {
            qtr = '3rd';
        } else {
            qtr = '4th';
        }
        let title = `${getPageTitle(this.props.type, 'quarterly', this.props.date, 'inspection')} `;
        return <BasePage pageTitle={ title /* `Quarterly Visual Form for ${qtr} Quarter of ${year}` */} className="quarterly-form" >
            <Async
                identifier="QTRVisualForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async" />}
                error={<ErrorPage />}
            />
        </BasePage >;
    }
}

export function mapStateToProps(state, ownProps) {
    const date = ownProps.match.params.date;
    const plantRegion = ownProps.match.params.region;
    const plantId = ownProps.match.params.plantId;
    const firstName = parseJwt(state.login.get('token')).First_Name;
    const lastName = parseJwt(state.login.get('token')).Last_Name;
    const formId = ownProps.match.params.formId;
    const questions = QuestionModel.getAllByType('QTRVisual');
    const formInstance = QuarterlyFormModel.get(ownProps.match.params.formId); 
    return {
        date, plantRegion, userUID: state.login.get('UniqueId'),
        userName: `${firstName} ${lastName}`, plantId,
        outfall: ownProps.match.params.outfall, questions, formId,
        type: 'QTRVisual',form: state.forms, formInstance
    };
}

export const QTRVisualForm =
    withRouter(connect<{}, {}, IQTRVisualFormProps>(mapStateToProps)(QTRVisualFormImpl as any));

const Row = ({ label, value }) => {
    return <div style={{ padding: '20px', fontSize: '18px' }} >
        <span> {label}</span>: &nbsp;&nbsp;<span style={{ color: '#A4BF43' }} >{value}</span>
    </div>;
};

const RadioButton = ({ label, natureOfDis, handleButtonClick, name }) => {
    return <button
        className={natureOfDis === label ? 'button-yes' : 'button-no'}
        type="button"
        onClick={() => handleButtonClick(label, name)}
    >
        {label}
    </button>;
};

const CustomInput = ({ placeholder, model, type, label, defaultValue }) => {
    return <InputRow
        quesNo=""
        model={model}
        onChange={null}
        placeholder={placeholder}
        type={type}
        label={label}
        defaultValue={defaultValue}
    />;
};

const BoldLabel = ({ label }) => {
    return <div style={{ padding: '20px', fontSize: '18px' }} >
        <span> <b> {label}</b>  </span>
    </div>;
};

const Label = ({ label }) => {
    return <div className="input-label" >
        <span key={1} >{label}</span>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/QuarterlyForm/QTRVisualForm.tsx